module.exports = __webpack_public_path__ + "img/login-car-v2-Abracaf.2e19d1e2.svg";